// extracted by mini-css-extract-plugin
export default {"section":"ControlType_section__kgssy","header":"ControlType_header__rgwb3","col":"ControlType_col__FusvW","footer":"ControlType_footer__WyonB","button":"ControlType_button__RsWjP"};